export const getCategoriesSectionContent = ({ i18n }) => ({
  title: i18n.gettext('¿Qué quieres comprar hoy?'),
  subtitle: i18n.gettext('Explora las categorías y decubre las tiendas donde puedes pagar con Cuotas sin Tarjeta'),
  /* i18n-next-line only: ["pt-BR"] */
  seeAllCategories: i18n.gettext('Conocer todas las categorías'),
});
